import { ProfileState, RootState, Profile } from "../types";
import { GetterTree, ActionTree, MutationTree, Module } from "vuex";
import { GET_PROFILE_DATA } from "./actions.names";
import { API_URL } from "../global";
import axios from "axios";
import { SET_PROFILE_DATA, SET_PROFILE_ERROR } from "./mutations.names";
import { USER_USERNAME, USER_FULL_NAME, USER_IDENTITY } from "./getters.names";

const namespaced: boolean = false;

export const state: ProfileState = {
  profile: undefined,
  error: false
};

export const getters: GetterTree<ProfileState, RootState> = {
  [USER_USERNAME](state: ProfileState): string | null {
    return state.profile ? state.profile.user.username : null;
  },
  [USER_FULL_NAME](state: ProfileState): string | null {
    if (state.profile) {
      if (state.profile.user.first_name || state.profile.user.last_name) {
        return `${state.profile.user.first_name} ${
          state.profile.user.last_name
        }`.trim();
      } else {
        return null;
      }
    } else {
      return null;
    }
  },
  [USER_IDENTITY](state: ProfileState, getters: any): string | null {
    return getters[USER_FULL_NAME]
      ? getters[USER_FULL_NAME]
      : getters[USER_USERNAME]
      ? getters[USER_USERNAME]
      : null;
  }
};

export const actions: ActionTree<ProfileState, RootState> = {
  async [GET_PROFILE_DATA]({ commit, rootState }: any) {
    const token = rootState.auth.authData
      ? rootState.auth.authData.key
      : null;
    if (token) {
      axios
        .get(`${API_URL}/others/customer-profile/`, {
          headers: {
            Authorization: `Token ${token}`
          }
        })
        .then(({ data }: any) => {
          commit(SET_PROFILE_DATA, data);
        })
        .catch((err: any) => {
          commit(SET_PROFILE_ERROR);
        });
    }
  }
};

export const mutations: MutationTree<ProfileState> = {
  [SET_PROFILE_DATA](state: any, data: Profile): any {
    state.profile = data;
    state.error = false;
  },
  [SET_PROFILE_ERROR](state: any): any {
    state.profile = undefined;
    state.error = true;
  }
};

export const ProfileData: Module<ProfileState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
